<template>
  <div>
    <div class="wrapper">
      <canvas :id="canvasId" class="truck" @contextmenu="rightClick($event)"></canvas>
    </div>
    <v-menu v-model="showMenu" :position-x="x" :position-y="y" absolute offset-y>
      <v-list>
        <v-list-tile class="remove-option" @click="removePallet" v-if="truck.status < 4">
          <v-list-tile-title>
            {{
            $t("truck_top.remove_pallet")
            }}
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile class="remove-option" @click="previewPallet">
          <v-list-tile-title>
            {{
            $t("truck_top.preview_pallet")
            }}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import Order from "@/models/Order.js";
import Helper from "@/models/Helper.js";
export default {
  props: [
    "truck",
    "pallets",
    "divider",
    "hideWarning",
    "orders",
    "manualUpdate"
  ],
  data() {
    return {
      offsets: {
        top: 50,
        left: 50
      },
      canvasId: this.getCanvasId(),
      showMenu: false,
      x: 0,
      y: 0,
      selectedPallet: null,
      loading: false,
      colors: [
        "#B5E61D",
        "#FFF200",
        "#99D9EA",
        "#FFAEC9",
        "#FF7F27",
        "#C8BFE7",
        "#00A2E8",
        "#22B14C",
        "#B5E61D",
        "#FFF200",
        "#99D9EA",
        "#FFAEC9",
        "#FF7F27",
        "#C8BFE7",
        "#00A2E8",
        "#22B14C",
        "#B5E61D",
        "#FFF200",
        "#99D9EA",
        "#FFAEC9",
        "#FF7F27",
        "#C8BFE7",
        "#00A2E8",
        "#22B14C"
      ]
    };
  },
  watch: {
    truck: {
      handler() {
        if (!this.manualUpdate) {
          this.initialize();
        }
      },
      deep: true
    },
    divider() {
      if (!this.manualUpdate) {
        this.initialize();
      }
    }
  },
  computed: {
    doesNotFit() {
      let maxWidth = 0;
      this.truck.pallets.forEach(pallet => {
        maxWidth = Math.max(maxWidth, pallet.truck_x + pallet.length);
      });
      return maxWidth > this.truck.length;
    }
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      let canvas = document.getElementById(this.canvasId);
      if (!canvas) return;
      let ctx = canvas.getContext("2d");
      const buyingLength = this.truck.getLength();
      const scale = 1 / this.divider;
      const offsets = Object.create(this.offsets);
      canvas.width = buyingLength / this.divider + offsets.left;
      canvas.height = this.truck.width / this.divider + offsets.top;
      ctx.fillStyle = this.truck.palletsFit() ? "rgb(99, 99, 91)" : "red";
      ctx.fillRect(
        offsets.left,
        offsets.top,
        buyingLength / this.divider + offsets.left,
        this.truck.width / this.divider
      ); //draw rectangles
      ctx.strokeStyle = "rgb(0,0,0)";
      drawTruckDimensions(this, canvas, ctx, offsets, buyingLength, this.truck);
      ctx.scale(scale, scale);
      ctx.lineWidth = 200 * (1 / this.divider);
      ctx.lineWidth = 10;
      drawPallets(
        this,
        ctx,
        this.pallets,
        this.truck,
        this.truck.pallets,
        offsets,
        scale
      );
    },
    enableEditing() {
      this.loading = false;
    },
    getCanvasId() {
      const random = Math.floor(Math.random() * 1000000);
      return `canvas${this.truck.id}${random}`;
    },
    rightClick(e) {
      if (this.loading) {
        return;
      }
      e.preventDefault();
      const offsets = Object.create(this.offsets);

      const pallets = this.truck.pallets.slice();
      const mousePos = {
        x: e.offsetX,
        y: e.offsetY
      };
      //try to find pallet within we're hovering
      const clickedPallet = pallets.find(e => {
        return (
          mousePos.x > e.truck_x / this.divider + offsets.left &&
          mousePos.x <
            (e.truck_x + e.getLength()) / this.divider + offsets.left &&
          mousePos.y > e.truck_y / this.divider + offsets.top &&
          mousePos.y < e.truck_y + e.getWidth() / this.divider + offsets.top
        );
      });

      this.showMenu = false;
      if (clickedPallet) {
        this.selectedPallet = clickedPallet;
        this.x = e.clientX;
        this.y = e.clientY;
        this.$nextTick(() => {
          this.showMenu = true;
        });
      }
    },
    async removePallet() {
      if (this.selectedPallet) {
        this.$store.commit("setLoading", true);
        this.loading = true;
        await this.selectedPallet.removeFromTruck(this.truck, this.pallets);
        this.$emit("updated");
      }
    },
    previewPallet() {
      if (this.selectedPallet) {
        this.$emit("palletSelected", this.selectedPallet);
      }
    }
  },
  components: {}
};

function drawTruckDimensions(vue, canvas, ctx, offsets, buyingLength, truck) {
  Helper.canvasArrow(
    ctx,
    offsets.left - 20,
    offsets.top,
    offsets.left - 20,
    canvas.height
  ); // draw height arrow bottom
  Helper.canvasArrow(
    ctx,
    offsets.left - 20,
    canvas.height,
    offsets.left - 20,
    offsets.top
  ); // draw height arrow top
  Helper.canvasArrow(
    ctx,
    offsets.left,
    offsets.top - 20,
    buyingLength + offsets.left,
    offsets.top - 20
  ); // draw height arrow right
  Helper.canvasArrow(
    ctx,
    buyingLength + offsets.left,
    offsets.top - 20,
    offsets.left,
    offsets.top - 20
  ); // draw height arrow left
  ctx.font = "16px Arial";
  ctx.fillStyle = "rgb(0,0,0)";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  const topText = Math.floor(buyingLength);
  const leftText = Math.floor(truck.width);
  ctx.fillText(topText, canvas.width / 2, offsets.top - 30); //truck length
  ctx.save();
  ctx.translate(offsets.left - 30, canvas.height / 2);
  ctx.rotate(-Math.PI / 2);
  ctx.fillText(leftText, 0, 0); //truck width text
  ctx.restore();
}

/**
 * draws pallets
 * @ctx
 * @pallets
 * @offsets - distance to move
 * @scale - transform back to original scale
 */
function drawPallets(vue, ctx, allPallets, truck, pallets, offsets, scale) {
  ctx.strokeStyle = "rgb(0,0,0)";
  const orders = Order.sortByPalletPriority(vue.truck, vue.orders);
  pallets.forEach(pallet => {
    ctx.fillStyle = "rgb(233, 215, 159)";
    const x = pallet.truck_x + offsets.left / scale;
    const y = pallet.truck_y + offsets.top / scale;
    let width = pallet.length;
    let height = pallet.width;
    if (pallet.is_turned) {
      width = pallet.width;
      height = pallet.length;
    }
    if (pallet.status >= 3) {
      ctx.fillStyle = "rgb(152, 209, 160)";
    }
    if (
      pallet.getLength() + pallet.truck_x > vue.truck.length ||
      pallet.getHeight() > vue.truck.height
    ) {
      ctx.fillStyle = "red";
    }
    if (!pallet.searched) {
      ctx.fillStyle = "rgb(207, 207, 207)";
    }
    ctx.fillRect(x, y, width, height); //draw rectangles
    //get color to match the one on selector
    ctx.fillStyle = pallet.getDispatchColor(
      orders,
      vue.colors,
      truck.company_id
    );
    if (pallet.searched) {
      ctx.fillRect(x + 200, y + 200, width - 200, height - 200); // draw inner rectangle with matching color
    }
    ctx.strokeRect(x, y, width, height); //draw borders
    drawPalletText(vue, ctx, allPallets, pallet, x, y, width, height); // draw text
  });
}

/**
 * draws pallets text
 * @param ctx
 * @param pallet
 * @param x
 * @param y
 * @param width
 * @param height
 */
function drawPalletText(vue, ctx, allPallets, pallet, x, y, width, height) {
  ctx.font = "160px Arial";
  ctx.fillStyle = "rgb(0,0,0)";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";

  const lengthTextX = x + pallet.length / 2;
  const lengthTextY = y + 100;
  ctx.fillText(width, lengthTextX, lengthTextY);

  const widthTextX = x + 100;
  const widthTextY = y + pallet.width / 2;
  ctx.save();
  ctx.translate(widthTextX, widthTextY);
  ctx.rotate(-Math.PI / 2);
  ctx.fillText(height, 0, 0); //truck width text
  ctx.restore();
  ctx.textAlign = "left";
  const contentX = x + 200;
  let contentY = y + 300;
  const palletIndex = allPallets
    ? `#${allPallets.map(pallet => pallet.id).indexOf(pallet.id) + 1}`
    : "#";
  const palletNumber =
    pallet.getNumber() != "" ? pallet.getNumber() : palletIndex;
  ctx.fillText(palletNumber, contentX, contentY); //truck width text
  let orders = getOrdersFromNumber(pallet);
  orders.forEach(order => {
    const orderTexts = order.split(" ");
    contentY += 200;
    ctx.fillText(orderTexts[0], contentX, contentY);
  });
}

function getOrdersFromNumber(pallet) {
  if (pallet.order_number == null) {
    return [];
  }
  let orders = pallet.order_number.split(", ");
  return orders;
}
</script>

<style scoped>
.wrapper {
  position: relative;
  top: 30%;
}
.does_not_fit {
  color: red;
  font-size: 1em;
  position: relative;
  left: 20%;
}
.context-menu {
  display: none;
}
.remove-option {
  cursor: pointer;
}
</style>
